import React from 'react';
import { CmsFeature } from '../../types/contentstack';
import LinkIcon from '../icons/LinkIcon';

interface CmsErrorHeroData {
  name?: string;
  component?: string;
  features: CmsFeature[];
}

interface CmsErrorHeroProps {
  data: CmsErrorHeroData;
}

const processBody = (html: string): string => {
  return html.replace(
    /<li>&nbsp;<\/li>/g,
    '</ul><div class="cms-or-divider flex items-center gap-[16px] px-[32px] self-stretch"><div class="flex-1 h-px bg-[#B1CAE4]"></div><span class="text-body-125 font-medium text-gray-925">Or</span><div class="flex-1 h-px bg-[#B1CAE4]"></div></div><ul>'
  );
};

const CmsErrorHero: React.FC<CmsErrorHeroProps> = ({ data }) => {
  return (
    <section className="flex justify-between items-start self-stretch py-800 px-500 bg-blue-0">
      {data.name && (
        <h2 className="text-heading-300 font-bold leading-[112.5%] tracking-[-1.44px] text-gray-925 max-w-[450px]">
          {data.name}
        </h2>
      )}
      <div className="flex flex-col gap-200 w-[627px]">
        {data.features.map((feature, index) => (
          <div
            key={feature._metadata?.uid ?? feature.heading}
            className={`flex flex-col items-start gap-200 pb-200 self-stretch ${
              index < data.features.length - 1 ? 'border-b border-[#B1CAE4]' : ''
            }`}
          >
            <h3 className="text-body-125 font-bold leading-[112.5%] tracking-[-0.3px] text-primary">
              {feature.heading}
            </h3>
            <div
              className="text-body-125 font-medium leading-[137.5%] text-gray-925 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:mt-100 [&_li]:mb-50 [&_a]:!text-[#003672] [&_a]:!no-underline [&_a]:text-body-125 [&_a]:font-medium [&_a]:leading-[137.5%] [&_strong]:font-bold"
              dangerouslySetInnerHTML={{ __html: processBody(feature.body) }}
            />
            {feature.buttons && feature.buttons.filter((b) => b.text).length > 0 && (
              <div className="flex gap-3 mt-50">
                {feature.buttons
                  .filter((b) => b.text)
                  .map((button, i) => (
                    <a
                      key={`${feature.heading}-button-${i}`}
                      href={button.url || undefined}
                      target={button.external ? '_blank' : '_self'}
                      rel={button.external ? 'noopener noreferrer' : undefined}
                      className="inline-flex items-center justify-center gap-[5px] min-w-[40px] min-h-[40px] px-125 py-100 rounded-200 bg-primary text-white font-semibold transition-colors hover:bg-primary-hover"
                    >
                      {button.text}
                      {button.icon && (
                        <LinkIcon
                          type={button.icon}
                          className={button.icon === 'ExternalIcon' ? 'w-4 h-4' : 'w-5 h-5'}
                        />
                      )}
                    </a>
                  ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default CmsErrorHero;
